import { createRequestException } from '~/helpers/requestException'
import { JurosBaixosSystemsAPI } from '~/helpers/axios/jurosbaixos-systems'
import {
  FgtsPostResponse,
  FgtsRequest,
  FgtsResponse,
} from '~/data/loans/fgts/offers'
import { AxiosResponse } from 'axios'
import { OfferStatus } from '~/data/common'

export const fetchFgtsOffers = async (payload: {
  status: OfferStatus | Array<OfferStatus>
}): Promise<AxiosResponse<Array<FgtsResponse> | Array<any>>> => {
  return await JurosBaixosSystemsAPI.get(`fgts/offers`, {
    params: Object.keys(payload).length > 0 ? payload : {},
  }).catch(createRequestException)
}

export const sendFgtsPostRequest = async (
  payload: FgtsRequest,
): Promise<AxiosResponse<FgtsPostResponse>> => {
  return await JurosBaixosSystemsAPI.post(`fgts/offers`, payload).catch(
    createRequestException,
  )
}

export const fetchFgtsOfferById = async (
  offerId: string,
): Promise<AxiosResponse<FgtsResponse>> => {
  return await JurosBaixosSystemsAPI.get(`fgts/offers/${offerId}`).catch(
    createRequestException,
  )
}
